module.exports = __webpack_public_path__ + "img/icon_map_sf_c.10b9c11a.png";